import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';

@Injectable({
  providedIn: 'root'
})
export class LifecycleEnrollmentService {
  private enrollmentByCompanyId = new Map<number, Observable<boolean>>();

  constructor(
    private masterService: MasterDataSeriveService,
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  // Whether the current company is enrolled in LifecycleJobCompanies — the v3 reports
  // rollout gate. Cached per companyId; fails closed (legacy report) on error.
  isEnrolled$(): Observable<boolean> {
    const companyId = this.masterService.getUserDetailsFromStorage().companyID;

    let cached = this.enrollmentByCompanyId.get(companyId);
    if (!cached) {
      const params = new HttpParams().set('companyId', companyId.toString());
      cached = this.http
        .get<{ isEnrolled: boolean }>(`${this.baseUrl}Reports/v3/LifecycleEnrollment`, { params })
        .pipe(
          map((response) => response.isEnrolled),
          catchError(() => {
            this.enrollmentByCompanyId.delete(companyId);
            return of(false);
          }),
          shareReplay(1)
        );
      this.enrollmentByCompanyId.set(companyId, cached);
    }

    return cached;
  }
}
